import { render, staticRenderFns } from "./UIMap.vue?vue&type=template&id=4f2ae2c6&scoped=true&"
import script from "./UIMap.vue?vue&type=script&lang=js&"
export * from "./UIMap.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=4f2ae2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ae2c6",
  null
  
)

export default component.exports